/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(document).ready(function(){
    $('.carouselTicker-one').carouselTicker({
        speed: 2,
        // mode: "vertical",
        direction: "next",
        pauseOnHover: false,
    });

    $('.carouselTicker-two').carouselTicker({
        speed: 2,
        // mode: "vertical",
        direction: "prev",
        pauseOnHover: false,
    });

    $(".quote-carousel").slick({
        dots: false,
        arrows: false,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
});

// Insert any custom theme js here...